<template>
    <div class="audio-player">
        <button @click.prevent="togglePlayer" class="audio-player__btn" :class="{ 'audio-player__btn--playing' : isPlaying}">
            <svg v-if="isPlaying" width="15" height="18" viewBox="0 0 15 18" fill="white" xmlns="http://www.w3.org/2000/svg">
                <rect x="0" width="5" height="18"/>
                <rect x="10" width="5" height="18"/>
            </svg>
            <svg v-else width="15" height="18" viewBox="0 0 15 18" fill="none" xmlns="http://www.w3.org/2000/svg" style="margin-left: 5px;">
                <path d="M13.1347 9L1 16.7066L1 1.29343L13.1347 9Z" fill="white" stroke="white" stroke-width="2"/>
            </svg>

        </button>
        <audio ref="audio" class="audio-player__audio" @ended="onEnd">
            <source
                    :src="audioUrl"
                    type="audio/mpeg"
            >
        </audio>
    </div>
</template>

<script>
    export default{
        props: {
            template:
                {
                    type: String,
                    default: "#vue-audio-player"
                },
            audioUrl: String
        },
        data() {
            return {
                isPlaying: false
            };
        },
        methods: {
            togglePlayer() {
                this.isPlaying = !this.isPlaying;
            },
            onEnd() {
                this.isPlaying = false;
            }
        },
        watch: {
            isPlaying(value) {
                if (value) {
                    this.$refs.audio.play();
                } else {
                    this.$refs.audio.pause();
                }
            }
        }
    }
</script>
